const CLASSNAMES = {
  link: "hover:underline hover:text-primary cursor-pointer",
};

const Footer = () => {
  return (
    <footer className="py-2 shadow-md shadow-black w-screen fixed text-center bottom-0 bg-white">
      <div className="flex flex-row justify-center gap-4 flex-wrap">
        <a
          href="mailto:consultants@techcyclesolutions.com"
          className={CLASSNAMES.link}
        >
          consultants@techcyclesolutions.com
        </a>
        |<span>913-717-7779</span>|
        <a href="https://techcyclesolutions.com" className={CLASSNAMES.link}>
          techcyclesolutions.com
        </a>
      </div>
    </footer>
  );
};

export default Footer;
